/* ------------------------------------------------------------------
// TODO: esbuild移行時に命名やimportできるようにリファクタリング必要
--------------------------------------------------------------------- */
$(document).ready(() => {
  $(".jsCleanForm").cleanQuery();
});
